export enum NavItemTypeEnum {
  divider = 'divider',
  title = 'title',
  dropdown = 'dropdown',
  label = 'label',
  empty = 'empty',
  link = 'link',
}
